module.exports = __webpack_public_path__ + "media/images/home-new-d355dac8e9aa798cd1a66fe8ff6ceea6.svg";